import { useEffect, useState } from 'react'
import { crud } from '@think-internet/zeus-frontend-package'
import props from '../../redux/props'
import { Analysis } from '../../types/Survey/Analysis/Analysis'

type Query = {
  surveyUUID: string
  organizationUnitUUID?: string | { $exists: false }
  dayNumber?: number | { $exists: false }
  userIdentifier: { $exists: false }
}

type OrganizationUnit = {
  value: string
  set: (unitUUID: string) => void
}

type DayNumber = {
  value: number
  set: (dayNumber: number) => void
}

const useGetSurveyAnalysis = (surveyUUID: string, initOrganizationUnit?: string, initDayNumber?: number): [Analysis, OrganizationUnit, DayNumber] => {
  const analysisFeature = crud.use(props.SURVEY_ANALYSIS)
  const [analysis, setAnalysis] = useState<Analysis>(null)
  const [selectedOrganizationUnit, setSelectedOrganizationUnit] = useState<string>(initOrganizationUnit || null)
  const [selectedDayNumber, setSelectedDayNumber] = useState<number>(initDayNumber || null)

  const organizationUnit: OrganizationUnit = {
    value: selectedOrganizationUnit,
    set: setSelectedOrganizationUnit,
  }

  const dayNumber: DayNumber = {
    value: selectedDayNumber,
    set: setSelectedDayNumber,
  }

  useEffect(() => {
    const pull = async () => {
      const query: Query = {
        surveyUUID,
        organizationUnitUUID: selectedOrganizationUnit || { $exists: false },
        userIdentifier: { $exists: false },
        dayNumber: selectedDayNumber || { $exists: false },
      }

      const analysis: Analysis = await analysisFeature.get(query)
      setAnalysis(analysis)
    }
    if (surveyUUID) pull()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [surveyUUID, selectedOrganizationUnit, selectedDayNumber])

  return [analysis, organizationUnit, dayNumber]
}

export default useGetSurveyAnalysis
